export default __webpack_public_path__ + "static/media/hr-solutions-1.0336754e.svg";